import { createApp } from 'vue';
import BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

if(document.getElementById('program-my-account')){
    const app = createApp({
        data() {
            return {
              user: {},
              program: {},
              counties: [],
              states: [],
              errors: [],
              programTypes: [],
            };
          },
        methods:{
            getProgramUser(){
                axios('/api/program-user')
                .then(function(response){
                    this.user = response.data
                    this.program = response.data.program
                    this.program.associations = this.program.associations || []
                    this.program.meals_provided = this.program.meals_provided || []
                    this.program.meals_provided_by = this.program.meals_provided_by || []
                    this.state_id = this.program.state_id
                }.bind(this))
                .catch(function(error){
                    console.error(error);
                })
            },
            getProgramTypes(){
                axios('/api/program-types')
                .then(function(response){
                    this.programTypes = response.data.data
                }.bind(this))
                .catch(function(error){
                    console.error(error);
                })
            },
            getStates(){
                axios('/api/states')
                .then(function(response){
                    this.states = response.data
                }.bind(this))
                .catch(function(error){
                    console.error(error);
                })
            },
            clearAssociationsNone() {
                if (this.program.associations.indexOf('none') > -1) {
                    this.program.associations.splice(this.program.associations.indexOf('none'),1);
                }
            },
            setError(error){
                this.errors[error] = true
                this.errors.push(error)
            },
            setPage(idx){
                this.page = idx
                window.location.href = "#edit";
            }
        },
        computed:{
            stateCounties: function(){
                if (this.states.length && this.program.state_id) {
                    return this.states.find(function (state) {
                        return state.id === this.program.state_id
                    }.bind(this)).counties
                }
               return [] 
            }
        },
        mounted: function(){
            this.getProgramTypes()
            this.getStates()
            this.getProgramUser()
        }
    });
    
    app.use(BootstrapVueNext);
    app.mount('#program-my-account');
}